import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MainView from './view/MainView';
import * as serviceWorker from './serviceWorker';
import i18 from './i18'
import {I18nextProvider} from 'react-i18next'
import {signIn, refreshToken, signInWithCode, auth_cfg, signOut} from "./api/api";
import {Auth} from '@q4us-sw/q4us-ui'
import {
    BrowserRouter as Router,
    Switch,
    Route, useLocation
} from 'react-router-dom'
import qs from "query-string";
import {AuthorizationCode} from "@q4us-sw/q4us-ui/lib/auth/AuthorizationCode";

Auth.configure({
    signIn: async (userName, passWord) => {
        const {access_token,refresh_token} = await signIn(userName,passWord)
        return {token:access_token, refreshToken: refresh_token}
    },
    refresh: async (token)=>{
        const {access_token,refresh_token} = await refreshToken(token)
        return {token: access_token, refreshToken: refresh_token}
    },
    signOut: async ()=>{
        await signOut(Auth.refreshToken)
        return true;
    },
    signInWithCode: async (authorizationCode, redirectUri)=>{
        const {access_token,refresh_token} = await signInWithCode(authorizationCode,redirectUri)
        return {token:access_token, refreshToken: refresh_token}
    }
})


export const View = (props)=>{
    let location = useLocation();
    const {code} = qs.parse(location.search);

    return <AuthorizationCode configs={async ()=>{
        const {data: cfg} = await auth_cfg();
        return cfg;
    }} code={code}>
        <MainView />
    </AuthorizationCode>
}


ReactDOM.render(
  <React.StrictMode>
      <Router>
          <Switch>
              <Route path={'/'}>
                  <I18nextProvider i18n={i18}>
                      <View/>
                  </I18nextProvider>
              </Route>
          </Switch>
      </Router>
  </React.StrictMode>,
    document.getElementsByTagName('body')[0]
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
